export default "__VITE_PUBLIC_ASSET__63e1b357__"